import React from "react";

interface Business {
  id: string;
  name: string;
}

interface BusinessListProps {
  businesses: Business[];
  loading: boolean;
  error: string | null;
  onRefresh: () => void;
  onAddBusiness: () => void;
}

const BusinessList: React.FC<BusinessListProps> = ({
  businesses,
  loading,
  error,
  onRefresh,
  onAddBusiness,
}) => {
  return (
    <div
      className="business-setup-container"
      style={{
        background: "white",
        borderRadius: "5px",
        padding: "1.5rem",
        marginBottom: "2rem",
        border: "1px solid #e5e7eb",
      }}
    >
      <div
        className="business-setup-header"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "1rem",
        }}
      >
        <h3>Business ({businesses.length})</h3>
        <div style={{ display: "flex", gap: "0.5rem" }}>
          <button
            className="wide-dash-border-btn"
            onClick={onRefresh}
            disabled={loading}
            title="Refresh Business List"
          >
            ↻ Refresh
          </button>
          <button
            className="wide-dash-border-btn"
            onClick={onAddBusiness}
            disabled={loading}
            title="Add Business"
          >
            ➕ Add Business
          </button>
        </div>
      </div>

      {loading && (
        <div
          className="loading-message"
          style={{ textAlign: "center", padding: "2rem" }}
        >
          <p>Loading businesses...</p>
        </div>
      )}

      {error && (
        <div
          className="error-message"
          style={{
            color: "red",
            textAlign: "center",
            padding: "1rem",
            backgroundColor: "#fee",
            borderRadius: "4px",
            marginBottom: "1rem",
          }}
        >
          <p>{error}</p>
        </div>
      )}

      {!loading && !error && businesses.length === 0 && (
        <div
          className="no-businesses"
          style={{
            textAlign: "center",
            padding: "2rem",
            color: "#666",
            fontStyle: "italic",
          }}
        >
          <p>No businesses found</p>
        </div>
      )}

      {!loading && businesses.length > 0 && (
        <div
          className="businesses-grid"
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
            gap: "1rem",
          }}
        >
          {businesses.map((business) => (
            <div
              key={business.id}
              className="business-card"
              style={{
                backgroundColor: "#f8f9fa",
                padding: "1.5rem",
                borderRadius: "8px",
                border: "1px solid #e9ecef",
                transition: "all 0.2s ease",
                cursor: "pointer",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "#e9ecef";
                e.currentTarget.style.transform = "translateY(-2px)";
                e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.1)";
                e.currentTarget.style.borderColor = "#667eea";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "#f8f9fa";
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "none";
                e.currentTarget.style.borderColor = "#e9ecef";
              }}
            >
              <div className="business-header" style={{ marginBottom: "1rem" }}>
                <h4 style={{ margin: 0, color: "#333" }}>🏢 {business.name}</h4>
              </div>
              <div className="business-details">
                <p
                  style={{
                    margin: "0.5rem 0",
                    fontSize: "0.9rem",
                    color: "#666",
                  }}
                >
                  <strong>ID:</strong> {business.id}
                </p>
                <div
                  className="business-actions"
                  style={{
                    marginTop: "1rem",
                    display: "flex",
                    gap: "0.5rem",
                  }}
                >
                  <button
                    className="wide-dash-border-btn"
                    style={{ fontSize: "0.8rem", padding: "0.4rem 0.8rem" }}
                    onClick={(e) => {
                      e.stopPropagation();
                      console.log("View business:", business.id);
                    }}
                  >
                    👁️ View
                  </button>
                  <button
                    className="wide-dash-border-btn"
                    style={{ fontSize: "0.8rem", padding: "0.4rem 0.8rem" }}
                    onClick={(e) => {
                      e.stopPropagation();
                      console.log("Edit business:", business.id);
                    }}
                  >
                    ✏️ Edit
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default BusinessList;
